import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27b8c6f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "col-12 flex justify-content-between bg-black-alpha-90 text-white tod p-0 m-0",
  style: {"font-size":"10px"}
}
const _hoisted_2 = { class: "mr-2" }

import { Result } from "@/interfaces/Result";
import { computed } from "vue";
import RdBolosMini from "./RdBolosMini.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RdResultBoardMini',
  props: {
    results: {},
    tod: {},
    isToday: { type: Boolean },
    icon: {},
    time: {},
    place: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const tm = computed(() => (props.time ? (props.time.length ? props.time[0] : "") : ""));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("i", {
        class: _normalizeClass([_ctx.icon, "ml-2"])
      }, null, 2),
      _createElementVNode("strong", null, _toDisplayString(_ctx.tod), 1),
      _createElementVNode("span", _hoisted_2, _toDisplayString(tm.value), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result, i) => {
      return (_openBlock(), _createBlock(RdBolosMini, {
        key: i,
        result: result,
        isToday: _ctx.isToday,
        place: _ctx.place
      }, null, 8, ["result", "isToday", "place"]))
    }), 128))
  ], 64))
}
}

})